import script from "./PersonalBest.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonalBest.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__